import {Injectable} from "@angular/core";
import {ProfessionCategoryApi} from "../../src/app/shared/sdk/services/custom/ProfessionCategory";

@Injectable()
export class ProfessionCategoriesUtils {

  constructor(protected categoriesApi: ProfessionCategoryApi) {}

  public loadProfessionCategories() {
    return this.categoriesApi.find();
  }
}



// WEBPACK FOOTER //
// ./common/utils/professioncategoriesutils.ts